import tribunalAPI from "../../api/tribunalAPi";
import { Login, Register, UserResponse } from "interfaces/authInterface";
import { BodyChangePassword } from "interfaces/auth/authInterfaces";

const getHoraImagen = async () => {
  let url = "/servicios-generales/obtener/hora-del-dia";
  return await tribunalAPI.get(url);
};
const getFAQService = async () => {
  let url = "/preguntas-frecuentes/secciones/con-preguntas";
  return await tribunalAPI.get(url);
}

const postLogin = async (body: Login) => {
  let url = "/auth/login";
  const response = await tribunalAPI.post(url, body);
  return response;
};

const postRegister = async (body: Register) => {
  let url = "/auth/registro";
  return await tribunalAPI.post(url, body);
};

const getUser = async () => {
  let url = `/auth/user`;
  return await tribunalAPI.get<UserResponse>(url);
};

const postChangePassword = async (body: BodyChangePassword) => {
  let url = "/auth/cahnge-password";
  return await tribunalAPI.post(url, body);
};

const getImagenPerfil = async () => {
  let url = "/user/obtener-imagen-perfil";
  return await tribunalAPI.get(url);
};

const postImagenPerfil = async <T>(body: T) => {
  let url = "/user/actualizar-imagen-perfil";
  return await tribunalAPI.post(url, body);
};

const postRefreshToken = async () => {
  let url = "/auth/refresh-token";
  return await tribunalAPI.post(url, {});
};

/**
 * Reset password routes
 */

const sendPasswordResetEmail = async <T>(queryParams: T) => {
  let url = "/auth/get-change-password-route";
  return await tribunalAPI.get(url, {
    params: queryParams
  });
};

const checkTokenValidity = async <T>(queryParams: T) => {
  let url = "/auth/get-token-validity";
  return await tribunalAPI.get(url, {
    params: queryParams
  });
}

const resetPassword = async <T>(body: T) => {
  let url = '/auth/password-route'
  return await tribunalAPI.post(url, body);
};

export {
  postRegister,
  postLogin,
  getUser,
  postChangePassword,
  getImagenPerfil,
  postImagenPerfil,
  postRefreshToken,
  sendPasswordResetEmail,
  checkTokenValidity,
  resetPassword,
  getHoraImagen,
  getFAQService,
};
